/**
 * v-collapse-toggle directive — drop-in replacement for BV2's v-b-toggle.
 *
 * Usage:
 *   v-collapse-toggle.some-id          — static id (modifier syntax)
 *   v-collapse-toggle="computedId"     — dynamic id (value syntax)
 *
 * Adds `collapsed` class to the element when the target collapse is hidden
 * (same behavior as BV2), enabling CSS arrow rotation via the class.
 */
export default {
    bind(el, binding, vnode) {
        const getId = () => binding.value || Object.keys(binding.modifiers)[0]

        el._collapseToggleHandler = () => {
            vnode.context.$root.$emit('collapse::toggle', getId())
        }

        el._collapseStateHandler = (id, isVisible) => {
            if (id === getId()) {
                el.classList.toggle('collapsed', !isVisible)
                el.classList.toggle('not-collapsed', isVisible)
            }
        }

        el.addEventListener('click', el._collapseToggleHandler)
        vnode.context.$root.$on('collapse::state', el._collapseStateHandler)
        el.style.cursor = 'pointer'
    },

    update(el, binding, vnode) {
        if (binding.value !== binding.oldValue) {
            el.removeEventListener('click', el._collapseToggleHandler)
            const getId = () => binding.value || Object.keys(binding.modifiers)[0]
            el._collapseToggleHandler = () => {
                vnode.context.$root.$emit('collapse::toggle', getId())
            }
            el.addEventListener('click', el._collapseToggleHandler)
        }
    },

    unbind(el, binding, vnode) {
        el.removeEventListener('click', el._collapseToggleHandler)
        vnode.context.$root.$off('collapse::state', el._collapseStateHandler)
        delete el._collapseToggleHandler
        delete el._collapseStateHandler
    },
}
